import {Component} from '@angular/core';

@Component({
  selector: 'bnpp-indx-home-disclaimer',
  imports: [],
  templateUrl: './home-disclaimer.component.html',
  styleUrl: './home-disclaimer.component.scss',
  standalone:true
})
export class HomeDisclaimerComponent{

}
